var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThundercoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.01461 11.2709C4.96397 11.3515 4.93582 11.4441 4.93309 11.5391C4.93036 11.6342 4.95314 11.7283 4.99908 11.8116C5.04501 11.8949 5.11241 11.9643 5.19428 12.0128C5.27615 12.0612 5.36949 12.0868 5.46461 12.0869H11.5441C11.5897 12.0867 11.6345 12.0987 11.6739 12.1217C11.7132 12.1448 11.7457 12.1779 11.7679 12.2177C11.7901 12.2576 11.8013 12.3026 11.8002 12.3482C11.799 12.3938 11.7857 12.4382 11.7616 12.4769L5.79461 22.0304C5.77976 22.0549 5.7601 22.0763 5.73679 22.0931C5.71349 22.1099 5.68703 22.1218 5.659 22.1281C5.63098 22.1344 5.60197 22.135 5.57372 22.1298C5.54546 22.1246 5.51856 22.1137 5.49461 22.0979C3.34481 20.7091 1.69473 18.67 0.784836 16.2779C-0.125058 13.8857 -0.247201 11.2655 0.436207 8.79905C1.11962 6.33262 2.57285 4.1489 4.58413 2.56616C6.59541 0.983407 9.05959 0.0843534 11.6176 2.10245e-05C11.6555 -0.000513276 11.6928 0.00914498 11.7257 0.0279856C11.7586 0.0468262 11.7858 0.0741569 11.8045 0.107119C11.8232 0.140081 11.8327 0.177464 11.832 0.215357C11.8313 0.25325 11.8205 0.290261 11.8006 0.322519L5.01461 11.2709ZM18.7245 2.05351C18.7009 2.03708 18.6741 2.02569 18.6459 2.02004C18.6177 2.01438 18.5886 2.01458 18.5605 2.02063C18.5324 2.02668 18.5058 2.03844 18.4824 2.05519C18.459 2.07194 18.4393 2.09332 18.4245 2.11801L12.5491 11.5304C12.525 11.569 12.5117 11.6133 12.5105 11.6588C12.5093 11.7042 12.5203 11.7492 12.5423 11.789C12.5643 11.8288 12.5966 11.8619 12.6358 11.885C12.6749 11.9082 12.7196 11.9204 12.7651 11.9204H18.8445C18.9396 11.9206 19.033 11.9462 19.1148 11.9946C19.1967 12.043 19.2641 12.1125 19.31 12.1958C19.356 12.2791 19.3788 12.3731 19.376 12.4682C19.3733 12.5633 19.3451 12.6559 19.2945 12.7364L12.4216 23.7433C12.4054 23.7693 12.3967 23.7992 12.3963 23.8298C12.3959 23.8603 12.4038 23.8904 12.4192 23.9168C12.4347 23.9432 12.457 23.9649 12.4838 23.9795C12.5107 23.9941 12.541 24.0012 12.5716 23.9998C15.0899 23.8778 17.506 22.9664 19.4775 21.3948C21.449 19.8231 22.876 17.671 23.5564 15.2432C24.2367 12.8155 24.1358 10.2352 23.2681 7.8679C22.4003 5.50064 20.8097 3.46644 18.7215 2.05351H18.7245Z",
    fill: "url(#paint0_linear_1267_29729)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1267_29729",
    x1: 10.3636,
    y1: 4.95298,
    x2: 14.583,
    y2: 23.0818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#00FFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#00F8D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00E4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00C3D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0096D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#005CD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#0016D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#0000D5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThundercoreIcon);
export default __webpack_public_path__ + "static/media/thundercoreIcon.7d0033cdb95a726c503ebf8919831d17.svg";
export { ForwardRef as ReactComponent };